import { PropsWithClassName } from "../../../models/props-with-class-name";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
import orderCreatedIcon from "../../../assets/orders/order_created.svg";
import styles from "./OrderCreatedIcon.module.css";

const OrderCreatedIcon = ({ className }: PropsWithClassName<{}>) => (
  <BaseIcon icon={orderCreatedIcon} className={`${styles.icon} ${className}`} />
);

export default OrderCreatedIcon;
